// extracted by mini-css-extract-plugin
var _1 = "fullContent___ZW4fw";
var _2 = "spinWrapper___uXrl2";
export { _1 as "fullContent", _2 as "spinWrapper" }
